export const footerConfig = {
  contact: {
    address: [
      "ul. Wiejska 1, ",
      "89-300 Wyrzysk",
    ],
    phone: "+48 (067) 286 77 09",
    email: "sekretariat@zspwyrzysk.pl",
  },

bip: {
    label: "Biuletyn Informacji Publicznej",

    href: "https://ckziuwyrzysk-bip.powiat.pila.pl/",

    logo: "/assets/images/logos/school-site/bip-logo.svg",

    external: true
}
};